import { API_BASE_URL } from "../config/api";

/** API origin without `/api/v1/` — used to resolve absolute media paths. */
function apiOrigin(): string {
  try {
    const u = new URL(API_BASE_URL);
    return `${u.protocol}//${u.host}`;
  } catch {
    return String(API_BASE_URL || "").replace(/\/api\/v1\/?$/i, "").replace(/\/$/, "");
  }
}

/**
 * Normalize product/color image payloads for <img src>.
 * Handles data-URIs, http(s), relative paths, and raw base64 (jpeg/png/gif/webp).
 */
export function toMediaSrc(raw?: string | null): string {
  let v = String(raw ?? "")
    .trim()
    .replace(/^"+|"+$/g, "");
  if (!v || v === "null" || v === "undefined" || v === "''" || v === '""') {
    return "";
  }

  // Already a usable URL / data URI / blob
  if (/^(data:|https?:|blob:)/i.test(v)) {
    return v;
  }

  // data URI missing the "data:" prefix (e.g. "image/jpeg;base64,...")
  if (/^image\/[a-z0-9.+-]+;base64,/i.test(v)) {
    return `data:${v}`;
  }

  // Absolute path on API host (production often stores `/uploads/...`)
  if (v.startsWith("/")) {
    const origin = apiOrigin();
    return origin ? `${origin}${v}` : v;
  }

  // Raw base64 — detect common image magic headers
  const compact = v.replace(/\s/g, "");
  if (compact.length > 32 && /^[A-Za-z0-9+/]+=*$/.test(compact)) {
    let mime = "image/jpeg";
    if (compact.startsWith("iVBOR")) mime = "image/png";
    else if (compact.startsWith("R0lGOD")) mime = "image/gif";
    else if (compact.startsWith("UklGR")) mime = "image/webp";
    else if (compact.startsWith("/9j/")) mime = "image/jpeg";
    return `data:${mime};base64,${compact}`;
  }

  return "";
}

export function getColorImage(color: any): string {
  return toMediaSrc(
    color?.colorImage ||
      color?.color_image ||
      color?.ColorImage ||
      color?.image ||
      color?.Image
  );
}
